import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

/** Section FAQ data-driven : items = [{ q, r }]. */
const FAQSection = ({ titre = 'Questions fréquentes', sousTitre, items, bg = 'bg-gray-50' }) => (
  <section className={`py-16 px-4 ${bg}`} data-testid="faq-section">
    <div className="max-w-4xl mx-auto">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">{titre}</h2>
        {sousTitre && <p className="text-lg text-gray-600">{sousTitre}</p>}
      </div>

      <Accordion type="single" collapsible className="space-y-4">
        {items.map((item, i) => (
          <AccordionItem key={item.q} value={`item-${i + 1}`} className={`${bg === 'bg-white' ? 'bg-gray-50' : 'bg-white'} rounded-lg px-6`}>
            <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-blue-600">{item.q}</AccordionTrigger>
            <AccordionContent className="text-gray-600">{item.r}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default FAQSection;
